import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { Link } from 'react-router-dom'

import { usePhotoUrl } from 'components/block/Profile/ProfilePhoto/hooks/usePhotoUrl'
import { BaseImage } from 'components/designSystem/BaseImage/BaseImage'

export const ProfilePhoto: FC<{
  photoId: number
  source: string
  incognito: boolean
}> = ({ photoId, source }) => {
  const photoUrl = usePhotoUrl(photoId)

  return (
    <Parent to={photoUrl} data-name={`photoviewer-${photoId}-action`}>
      <Image
        imageSource={source}
        alt=""
        title=""
        data-name={`photoviewer-${photoId}-photo`}
      />
    </Parent>
  )
}

const Parent = styled(Link)`
  display: block;
  position: relative;
  padding-bottom: 130%;
  clip-path: polygon(
    0.004% 9%,
    0.004% 9%,
    0.064% 7.989%,
    0.268% 6.864%,
    0.647% 5.678%,
    1.236% 4.482%,
    2.066% 3.328%,
    3.172% 2.268%,
    4.586% 1.353%,
    6.342% 0.636%,
    8.472% 0.168%,
    11.009% 0%,
    11.009% 0%,
    13.124% 0.01%,
    15.775% 0.04%,
    18.892% 0.086%,
    22.405% 0.149%,
    26.244% 0.225%,
    30.338% 0.313%,
    34.617% 0.412%,
    39.01% 0.518%,
    43.447% 0.632%,
    47.858% 0.75%,
    47.858% 0.75%,
    51.479% 0.837%,
    55.196% 0.905%,
    58.968% 0.955%,
    62.752% 0.99%,
    66.505% 1.012%,
    70.185% 1.024%,
    73.751% 1.027%,
    77.159% 1.025%,
    80.367% 1.019%,
    83.334% 1.011%,
    83.334% 1.011%,
    83.975% 1.009%,
    84.601% 1.008%,
    85.211% 1.006%,
    85.804% 1.005%,
    86.381% 1.003%,
    86.94% 1.002%,
    87.481% 1.001%,
    88.003% 1.001%,
    88.507% 1%,
    88.991% 1%,
    88.991% 1%,
    90.154% 1.039%,
    91.486% 1.174%,
    92.92% 1.432%,
    94.385% 1.841%,
    95.814% 2.429%,
    97.138% 3.222%,
    98.287% 4.248%,
    99.193% 5.535%,
    99.787% 7.11%,
    100% 9%,
    100% 91%,
    100% 91%,
    99.791% 92.668%,
    99.207% 94.084%,
    98.316% 95.266%,
    97.182% 96.232%,
    95.872% 97%,
    94.451% 97.588%,
    92.987% 98.014%,
    91.545% 98.296%,
    90.191% 98.452%,
    88.991% 98.5%,
    88.991% 98.5%,
    85.738% 98.505%,
    81.832% 98.52%,
    77.403% 98.549%,
    72.584% 98.591%,
    67.504% 98.65%,
    62.295% 98.727%,
    57.088% 98.823%,
    52.015% 98.942%,
    47.207% 99.083%,
    42.795% 99.25%,
    42.795% 99.25%,
    38.664% 99.417%,
    34.64% 99.558%,
    30.76% 99.677%,
    27.066% 99.773%,
    23.596% 99.85%,
    20.391% 99.909%,
    17.49% 99.951%,
    14.933% 99.98%,
    12.76% 99.995%,
    11.009% 100%,
    11.009% 100%,
    8.36% 99.836%,
    6.165% 99.376%,
    4.383% 98.67%,
    2.972% 97.768%,
    1.892% 96.719%,
    1.101% 95.572%,
    0.557% 94.377%,
    0.22% 93.184%,
    0.048% 92.042%,
    0% 91%,
    0% 9%,
    0.004% 9%
  );
`

const Image = styled(BaseImage)`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`
